import { useEffect } from 'react';
import { useRouteError } from 'react-router-dom';
import * as Sentry from '@sentry/react';
import { ErrorFallback } from './ErrorFallback';

// Les erreurs de rendu levées SOUS le routeur ne remontent jamais jusqu'à
// ErrorBoundary : react-router les intercepte et affichait son écran de debug
// « Unexpected Application Error! » en prod. Ce fallback, posé en errorElement
// sur la route racine, rend le même écran que ErrorBoundary et trace l'erreur.
export function RouteErrorFallback() {
  const error = useRouteError();

  useEffect(() => {
    Sentry.captureException(error);
  }, [error]);

  return <ErrorFallback />;
}
